import React from "react";
import { withRouter } from "react-router-dom";
import ProfileSettingComponent from "./ProfileSettingComponent";

const ProfileSettingsLanding = () => {
  return <ProfileSettingComponent />
};
export default withRouter(ProfileSettingsLanding);